import { render, staticRenderFns } from "./LocalInfoCreate.vue?vue&type=template&id=ccb23654&scoped=true"
import script from "./LocalInfoCreate.vue?vue&type=script&lang=js"
export * from "./LocalInfoCreate.vue?vue&type=script&lang=js"
import style0 from "./LocalInfoCreate.vue?vue&type=style&index=0&id=ccb23654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb23654",
  null
  
)

export default component.exports